/* eslint-disable */
import React, { forwardRef, useImperativeHandle, useRef, useState, useMemo, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import CustomTooltipCellRenderer from './custom_grid_tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { useLocation } from 'react-router-dom';

const AgGridComponent = forwardRef(({ totalCount, rowData = [], columnDefs = [], defaultColDef = null, rowSelection = {}, checkedIndexes = [], pagination = true, hasNextPage, currentPage,
    paginationPageSize = 10, gridHeight = 400, theme = 'ag-theme-quartz', additionalGridProps = {}, sendSelectedRows, sendPaginationInfo, isEntraApproval=false, isRetirementApproval=false, isMyPamApproval=false, isSSOApproval=false }, ref) => {
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setColumnApi] = useState(null);
    const gridRef = useRef(null);
    const { state } = useLocation();
    const totalPages = Math.ceil(isEntraApproval ? ((state?.entraCount || sessionStorage.getItem('entraCount') || 0) / paginationPageSize) : isRetirementApproval ? ((state?.retirementCount || sessionStorage.getItem('retirementCount') || 0) / paginationPageSize) : isMyPamApproval ? ((state?.myPamCount || sessionStorage.getItem('myPamCount') || 0) / paginationPageSize) : isSSOApproval ? ((state?.ssoCount || sessionStorage.getItem('ssoCount') || 0) / paginationPageSize) : ((state?.myidMApprovalCount || sessionStorage.getItem('myidMApprovalCount') || 0) / paginationPageSize) );
    currentPage = currentPage + 1;
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows();
        gridApi.setColumnVisible('actions', selectedRows.length <= 1);
        sendSelectedRows(selectedRows);
    };

    const onPaginationChanged = (type) => {
        if (gridApi) {
            let page;
            if (type === 'next') {
                if (!hasNextPage) return;
                page = currentPage + 1;
            } else if (type === 'previous') {
                if (currentPage === 1) return;
                page = currentPage - 1;
            }
            else if (type === 'first') {
                page = 1;
            }
            else if (type === 'last') {
                page = totalPages;
            }
            sendPaginationInfo({ page: page - 1, pageSize: paginationPageSize });
            console.log(`Current Page: ${page} of ${totalPages}`);
        }
    };

    const defaultColumnDefs = useMemo(() => {
        return (
            defaultColDef || {
                filter: 'agTextColumnFilter',
                floatingFilter: false,
                resizable: true,
            }
        );
    }, [defaultColDef]);

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi);
        params?.api?.forEachNode((node, index) => {
            if (checkedIndexes?.includes(index)) {
                node?.setSelected(true);
            }
            else {
                node?.setSelected(false);
            }
        });
    };

    return (
        <div className={theme} style={{ height: gridHeight }}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColumnDefs}
                rowSelection={rowSelection}
                enableCellTextSelection={true}
                suppressMovableColumns={true}
                // pagination={pagination}
                // paginationPageSize={paginationPageSize}
                onGridReady={onGridReady}
                {...additionalGridProps}
                onSelectionChanged={onSelectionChanged}
            // onPaginationChanged={onPaginationChanged}
            />
            <Tooltip id="ag-grid-tooltip"
                delayShow={200}
                style={{
                    zIndex: 9999,
                    backgroundColor: "#333",
                    color: "#fff",
                    padding: "8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    maxWidth: "250px",
                    whiteSpace: "normal",
                    height: 'auto',
                    opacity: 1,
                }}
                place="top" anchorSelect="[data-tooltip-id='ag-grid-tooltip']" />
            <div className="ag-paging-panel ag-unselectable ag-focus-managed" id="ag-109" aria-hidden="false"><div class="ag-tab-guard ag-tab-guard-top" role="presentation" tabindex="0"></div>                
                {/* <span className="ag-paging-row-summary-panel" style={{display: 'flex', gap:'4px'}}>
                    <span id="ag-109-first-row" data-ref="lbFirstRowOnPage" className="ag-paging-row-summary-panel-number">{(currentPage - 1) * paginationPageSize + 1}</span>
                    <span id="ag-109-to">to</span>
                    <span id="ag-109-last-row" data-ref="lbLastRowOnPage" className="ag-paging-row-summary-panel-number">{totalCount < currentPage * paginationPageSize ? totalCount : currentPage * paginationPageSize}</span>
                    <span id="ag-109-of">of</span>
                    <span id="ag-109-row-count" data-ref="lbRecordCount" className="ag-paging-row-summary-panel-number">{totalCount}</span>
                </span> */}
                <span className="ag-paging-page-summary-panel" role="presentation">
                    <div data-ref="btFirst" className={currentPage === 1 ? "ag-button ag-paging-button ag-disabled cursor-not-allowed" : "ag-button ag-paging-button"} role="button" aria-label="First Page" tabindex="0" aria-disabled={currentPage === 1} onClick={() => onPaginationChanged('first')}><span className="ag-icon ag-icon-first" unselectable="on" role="presentation"></span></div>
                    <div data-ref="btPrevious" onClick={() => onPaginationChanged('previous')} className={currentPage === 1 ? "ag-button ag-paging-button ag-disabled cursor-not-allowed" : "ag-button ag-paging-button"} role="button" aria-label="Previous Page" tabindex="0" aria-disabled={currentPage === 1}><span className="ag-icon ag-icon-previous" unselectable="on" role="presentation"></span></div>
                    <span className="ag-paging-description" style={{display: 'flex', gap:'4px'}}>
                        <span id="ag-109-start-page">Page</span>
                        <span id="ag-109-start-page-number" data-ref="lbCurrent" className="ag-paging-number">{currentPage}</span>
                        {/* <span id="ag-109-of-page">of</span>
                        <span id="ag-109-of-page-number" data-ref="lbTotal" className="ag-paging-number">{Math.ceil(totalCount / paginationPageSize)}</span> */}
                    </span>
                    <div data-ref="btNext" className={hasNextPage ? "ag-button ag-paging-button " : "ag-button ag-paging-button ag-disabled cursor-not-allowed"} role="button" aria-label="Next Page" tabindex="0" aria-disabled={!hasNextPage}><span className="ag-icon ag-icon-next" unselectable="on" role="presentation" onClick={() => onPaginationChanged('next')}></span></div>
                    <div data-ref="btLast" className={hasNextPage ? "ag-button ag-paging-button " : "ag-button ag-paging-button ag-disabled cursor-not-allowed"} role="button" aria-label="Last Page" tabindex="0" aria-disabled={currentPage === Math.ceil(sessionStorage.getItem('myidMApprovalCount') / paginationPageSize)} onClick={() => onPaginationChanged('last')}><span className="ag-icon ag-icon-last" unselectable="on" role="presentation"></span></div>
                </span>
                <div className="ag-tab-guard ag-tab-guard-bottom" role="presentation" tabindex="0"></div>
            </div>
        </div>
    );
});

export default AgGridComponent;

